<template>
  <div id="printerDiv">
    <table class="ana">
      <tr>
        <td>
          <table style="min-width: 120mm">
            <tr>
              <td class="fontM" style="width: 50mm" valign="top">
                <div v-if="activePersonal != null && activePersonal != ''">
                  Kullanıcı : {{ activePersonal }}
                </div>
              </td>

              <td class="fontM" style="width: 40mm" valign="top">
                Fiş No : {{ billId }}
              </td>
            </tr>
            <tr>
              <td class="fontM" style="width: 64mm" valign="top" colspan="2">
                Tarih : &nbsp;&nbsp;&nbsp; {{ currentDateTime }}
              </td>
            </tr>
          </table>
          <table style="min-width: 64mm">
            <thead>
              <tr class="border-bottom" style="display: block; width: 85mm">
                <td
                  class="heavy fontM"
                  style="width: 50mm; height: 20px"
                  valign="top"
                >
                  Ürün
                </td>
                <td class="heavy fontM" style="width: 15mm" valign="top">
                  Miktar
                </td>
                <td class="heavy fontM" style="width: 20mm" valign="top">
                  Tutar
                </td>
              </tr>
            </thead>
            <tbody>
              <tr
                style="width: 85mm"
                v-for="entry in orderEntries"
                :key="entry.id"
              >
                <td>
                  <table>
                    <tr>
                      <td class="fontB" style="width: 50mm" valign="top">
                        {{ entry.productName }}
                      </td>
                      <td class="fontB" style="width: 15mm" valign="top">
                        x{{ entry.productQuantity || entry.quantity }}
                      </td>
                      <td class="fontB" style="width: 20mm" valign="top">
                        {{ $toCurrency(entry.price) }}
                      </td>
                    </tr>
                  </table>
                  <table>
                    {{
                      entry.description
                    }}
                    <tr
                      v-if="entry.variantItems != null"
                      style="width: 85mm"
                      v-for="variant in entry.variantItems"
                      :key="variant.id"
                    >
                      <td class="fontMB" style="width: 50mm" valign="top">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;* {{ variant.name }}
                      </td>
                      <td class="fontMB" style="width: 15mm" valign="top"></td>
                      <td class="fontMB" style="width: 20mm" valign="top"></td>
                    </tr>
                  </table>
                  <table v-if="(entry.recipe && (entry.recipe.steps || entry.recipe.Steps || entry.recipe.recipeSteps || entry.recipe.RecipeSteps)) || (entry.Recipe && (entry.Recipe.steps || entry.Recipe.Steps || entry.Recipe.recipeSteps || entry.Recipe.RecipeSteps)) || (entry.recipeSteps || entry.RecipeSteps)">
                    <tr
                      style="width: 85mm"
                      v-for="step in ((entry.recipe && (entry.recipe.steps || entry.recipe.Steps || entry.recipe.recipeSteps || entry.recipe.RecipeSteps)) || (entry.Recipe && (entry.Recipe.steps || entry.Recipe.Steps || entry.Recipe.recipeSteps || entry.Recipe.RecipeSteps)) || entry.recipeSteps || entry.RecipeSteps || []).filter(x => x.isRemoved || x.IsRemoved || (x.selected && !x.isDefault) || (x.Selected && !x.IsDefault))"
                      :key="step.id"
                    >
                      <td
                        v-if="!(step.isRemoved || step.IsRemoved)"
                        class="fontMB"
                        style="width: 50mm"
                        valign="top"
                      >
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;* {{ (step.name || step.Name || (step.rawMaterial && step.rawMaterial.name) || (step.rawMaterial && step.rawMaterial.Name) || (step.rawmaterial && step.rawmaterial.name) || (step.rawmaterial && step.rawmaterial.Name) || (step.productName) || (step.product && step.product.name) || '').trim() }}
                      </td>
                      <td
                        v-else
                        class="fontMB"
                        style="width: 50mm"
                        valign="top"
                      >
                        <span
                          style="text-decoration: line-through"
                          class="text-line-through"
                        >
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- {{ (step.name || step.Name || (step.rawMaterial && step.rawMaterial.name) || (step.rawMaterial && step.rawMaterial.Name) || (step.rawmaterial && step.rawmaterial.name) || (step.rawmaterial && step.rawmaterial.Name) || '').trim() }}
                        </span>
                      </td>
                      <td class="fontMB" style="width: 15mm" valign="top"></td>
                      <td class="fontMB" style="width: 20mm" valign="top"></td>
                    </tr>
                  </table>
                  <table>
                    <template v-for="extra in (entry.extras || [])">
                      <tr
                        v-if="(Number(extra.quantity) || 0) > 0"
                        :key="extra.id"
                        style="width: 85mm"
                      >
                        <td class="fontMB" style="width: 50mm" valign="top">
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+ {{ extra.name }}
                        </td>
                        <td class="fontMB" style="width: 15mm" valign="top">
                          x{{ extra.quantity }}
                        </td>
                        <td class="fontMB" style="width: 20mm" valign="top">
                          {{ $toCurrency(extra.price) }}
                        </td>
                      </tr>
                    </template>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </table>
    <div
      v-if="
        orderDetail.paymentInformations &&
        orderDetail.paymentInformations.length > 0
      "
      style="margin: 10px 0"
    >
      <strong>Ödeme Yöntemi:</strong>
      <span>{{ orderDetail.paymentInformations[0].paymentMethod.name }}</span>
    </div>
    <table
      v-if="orderDetail.deliveryModel"
      style="width: 100%; margin-bottom: 10px"
    >
      <tr>
        <td><strong>Adres:</strong></td>
        <td>{{ orderDetail.deliveryModel.address }}</td>
      </tr>
      <tr>
        <td><strong>Apartman No:</strong></td>
        <td>{{ orderDetail.deliveryModel.apartmentNumber }}</td>
      </tr>
      <tr>
        <td><strong>Kat:</strong></td>
        <td>{{ orderDetail.deliveryModel.floor }}</td>
      </tr>
      <tr>
        <td><strong>Kapı No:</strong></td>
        <td>{{ orderDetail.deliveryModel.doorNo }}</td>
      </tr>
      <tr>
        <td><strong>Açıklama:</strong></td>
        <td>{{ orderDetail.description }}</td>
      </tr>
      <tr>
        <td><strong>Telefon:</strong></td>
        <td>{{ orderDetail.deliveryModel.phoneNumber }}</td>
      </tr>
      <tr>
        <td><strong>Kapı Çalınmasın:</strong></td>
        <td>
          {{ orderDetail.deliveryModel.doNotKnockDoor ? "Evet" : "Hayır" }}
        </td>
      </tr>
      <tr>
        <td><strong>Kapıya Bırak:</strong></td>
        <td>
          {{ orderDetail.deliveryModel.dropOffAtDoor ? "Evet" : "Hayır" }}
        </td>
      </tr>
      <tr>
        <td><strong>Doğrulama Kodu:</strong></td>
        <td>{{ orderDetail.confirmationNumber }}</td>
      </tr>
    </table>
    <table style="width: 100%">
      <tr class="text-end justify-end">
        <span class="heavy fontM text-end"
          >Toplam Tutar : {{ $toCurrency(totalPrice) }}</span
        >
      </tr>
      <tr class="text-end justify-end">
        <span class="heavy fontM text-end"
          >Toplam İndirim : {{ $toCurrency(totalDiscountPrice) }}</span
        >
      </tr>
      <tr class="text-end justify-end">
        <span class="heavy fontM text-end"
          >Toplam Net Tutar :
          {{ $toCurrency(totalPrice - totalDiscountPrice) }}</span
        >
      </tr>
    </table>
  </div>
</template>
<script src="https://www.google.com/cloudprint/client/cpgadget.js" />
<script>
import companyInfo from "../../../model/constants/companyInfo";
import print from "print-js";

export default {
  props: {
    orderDetail: {
      type: Object,
      required: false,
    },
    totalPrice: {
      type: Number,
      required: false,
    },
    totalDiscountPrice: {
      type: Number,
      required: false,
    },
    orderEntries: {
      type: Array,
      required: false,
    },
    currentDateTime: {
      type: String,
      required: false,
    },
    activePersonal: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      companyName: companyInfo.name,
    };
  },
  computed: {
    billId: {
      get() {
        return this.$store.getters["selfservice/getToLastBillId"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLastBillId", val);
      },
    },
  },
  methods: {
    printOrders() {
      try {
        console.log(this.orderEntries);

        const el = document.getElementById("printerDiv");
        console.log("printerDiv:", el);

        printJS({
          showModal: false,
          printable: "printerDiv",
          type: "html",
          header: this.companyName,
          style:
            ".heavy {font-weight: 800;} .justify-end{justify-content:flex-end;} .text-end{text-align:end;} .border-bottom {border-bottom:1px solid #000000;} .fontB {font-size:22px!important;font-weight:600;} .fontM {font-size:16px!important;} .fontMB {font-size:19px!important;} .text-line-through {text-decoration:line-through;}",
        });
      } catch (e) {}
    },
  },
};
</script>

<style>
#printerDiv {
  position: absolute;
  left: 30%;
  top: 5%;
  z-index: -1;
  font-size: 15px;
  max-width: 80mm;
  min-height: 150mm;
  line-height: 1; /* Satır yüksekliği */
  margin-bottom: 0; /* Alt boşluk */
  padding-bottom: 0; /* Alt dolgu */
}
#printerDiv table {
  margin-bottom: 0; /* Alt boşluk */
}

#printerDiv table td {
  padding-bottom: 0; /* Alt dolgu */
}
</style>
